

const TiktokIntegration = () => {


    return 'Got it'
}

export default TiktokIntegration;